module.exports = __webpack_public_path__ + "static/media/programa-lapis.4f084942.png";